import { FC, useMemo } from "react";
import { Stack } from "@mui/material";
import formatNumber from "../../../utils/formatNumber";
import { Strategy } from "../../../store/slices/strategySlice";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { precision } from "../../../utils/_precision";
import DottedTextField from "../../../_components/DottedTextField";
import Text from "../../../_components/Text";

interface AutoStrategyDetailsInfoProps {
  strategy: Strategy;
  accountName: string;
}

const AutoStrategyDetailsInfo: FC<AutoStrategyDetailsInfoProps> = ({ strategy, accountName }) => {
  const tickers = useSelector((state: RootState) => state.shared.tickers);

  const tickerPriceStep = useMemo(() => {
    let foundPriceStep = tickers.find(
      (ticker) => ticker.base === strategy.base && ticker.quote === strategy.quote
    )?.priceStep;
    if (foundPriceStep) {
      return precision(foundPriceStep);
    } else {
      return 4;
    }
  }, [strategy.base, strategy.quote, tickers]);

  return (
    <Stack width="100%">
      <Text variant="h2" mb="16px">
        Details
      </Text>

      <Stack width="100%" direction="column" gap="8px">
        <DottedTextField placeholder={"Account"} value={accountName} />

        <DottedTextField
          placeholder={"Low price"}
          value={`${formatNumber(strategy.minPrice, tickerPriceStep)} ${strategy.quote}`}
        />

        <DottedTextField
          placeholder={"High price"}
          value={`${formatNumber(strategy.maxPrice, tickerPriceStep)} ${strategy.quote}`}
        />
      </Stack>
    </Stack>
  );
};

export default AutoStrategyDetailsInfo;
